(function () {
  "use strict";

  // ------------------------------------------------------------
  // このJSは、ページ内のLiquidが出力した data-lang 一覧
  // （bmsg_languages）と data-market-suffixes
  // （bmsg_market_suffixes）を読み取り、
  //   1. 今アクセスしているURLが「どの言語」「どのマーケット」か
  //   2. メニューで選んだ言語に切り替えるとどのURLになるか
  // を自動計算します。
  //
  // 国やマーケットが増えても、Liquid側の設定リストに
  // 1行足すだけでこのJSはそのまま動きます。
  // ------------------------------------------------------------

  const DEFAULT_LANGUAGE = "ja";
  const DEFAULT_MARKET = ""; // プライマリー（日本）

  const mediaQuery = window.matchMedia("(min-width: 768px)");

  function getSwitcherConfig(switcher) {
    // 現在地の判定・URL組み立てには「常にフルの言語セット」を使う必要がある。
    // limited_langs により画面上のボタンが絞られていても、
    // 判定ロジックまで一緒に絞られてはいけないため、
    // data-all-languages（Liquid側で出力した全言語コード一覧）を優先して読む。
    const allLanguagesAttr = switcher.dataset.allLanguages || "";
    let languages = allLanguagesAttr
      .split(",")
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);

    // 後方互換: data-all-languages が無い場合は、表示中のボタンから拾う
    if (!languages.length) {
      languages = Array.from(
        switcher.querySelectorAll("[data-lang]")
      ).map(function (item) {
        return item.dataset.lang;
      });
    }

    const marketSuffixes = (switcher.dataset.marketSuffixes || "")
      .split(",")
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);

    return { languages: languages, marketSuffixes: marketSuffixes };
  }

  // 現在のURLの先頭セグメントを解析し、
  // { lang, market, consumed } を返す。
  // consumed が true の場合、そのセグメントはロケール情報として
  // 認識できたことを示す（URL組み立て時に取り除く対象）。
  function parseLocationSegment(segment, config) {
    if (!segment) {
      return { lang: DEFAULT_LANGUAGE, market: DEFAULT_MARKET, consumed: false };
    }

    // 1. 「言語コード-マーケットサフィックス」のパターンを試す
    //    例: "zh-hant-hk" -> lang: "zh-hant", market: "hk"
    for (let i = 0; i < config.marketSuffixes.length; i++) {
      const suffix = config.marketSuffixes[i];
      const tail = "-" + suffix;

      if (segment.length > tail.length && segment.endsWith(tail)) {
        const candidateLang = segment.slice(0, segment.length - tail.length);

        if (config.languages.indexOf(candidateLang) !== -1) {
          return { lang: candidateLang, market: suffix, consumed: true };
        }
      }
    }

    // 2. プライマリー市場の「言語コードのみ」のパターンを試す
    //    例: "en" -> lang: "en", market: ""(プライマリー)
    if (config.languages.indexOf(segment) !== -1) {
      return { lang: segment, market: DEFAULT_MARKET, consumed: true };
    }

    // 3. どちらにも該当しない場合は、ロケール以外のパス
    //    （このセグメントは通常のページパスとして扱う）
    return { lang: DEFAULT_LANGUAGE, market: DEFAULT_MARKET, consumed: false };
  }

  function getCurrentLocation(config) {
    const segments = window.location.pathname.split("/").filter(Boolean);
    const firstSegment = segments[0] || "";

    return parseLocationSegment(firstSegment, config);
  }

  function getCleanSegments(config) {
    const segments = window.location.pathname.split("/").filter(Boolean);
    const firstSegment = segments[0] || "";
    const parsed = parseLocationSegment(firstSegment, config);

    return parsed.consumed ? segments.slice(1) : segments;
  }

  function buildPrefixForLanguage(lang, market) {
    if (!market) {
      // プライマリー（日本）市場: 日本語は接頭辞なし
      return lang === DEFAULT_LANGUAGE ? "" : "/" + lang;
    }

    return "/" + lang + "-" + market;
  }

  function createLocalizedUrl(switcher, targetLang) {
    const config = getSwitcherConfig(switcher);
    const currentLocation = getCurrentLocation(config);
    const cleanSegments = getCleanSegments(config);

    const prefix = buildPrefixForLanguage(targetLang, currentLocation.market);
    const cleanPath =
      cleanSegments.length > 0 ? "/" + cleanSegments.join("/") : "/";

    const search = window.location.search || "";
    const hash = window.location.hash || "";

    if (!prefix) {
      return cleanPath + search + hash;
    }

    if (cleanPath === "/") {
      return prefix + "/" + search + hash;
    }

    return prefix + cleanPath + search + hash;
  }

  function closeSwitcher(switcher) {
    if (!switcher) return;

    const button = switcher.querySelector("[data-fanclub-lang-button]");
    const menu = switcher.querySelector("[data-fanclub-lang-menu]");

    switcher.classList.remove("is-open");

    if (button) {
      button.setAttribute("aria-expanded", "false");
    }

    if (menu) {
      menu.setAttribute("aria-hidden", "true");
    }
  }

  function openSwitcher(switcher) {
    document
      .querySelectorAll("[data-fanclub-lang].is-open")
      .forEach(function (otherSwitcher) {
        if (otherSwitcher !== switcher) {
          closeSwitcher(otherSwitcher);
        }
      });

    const button = switcher.querySelector("[data-fanclub-lang-button]");
    const menu = switcher.querySelector("[data-fanclub-lang-menu]");

    switcher.classList.add("is-open");

    if (button) {
      button.setAttribute("aria-expanded", "true");
    }

    if (menu) {
      menu.setAttribute("aria-hidden", "false");
    }
  }

  function setLabel(switcher) {
    const label = switcher.querySelector("[data-fanclub-lang-label]");
    const config = getSwitcherConfig(switcher);
    const currentLocation = getCurrentLocation(config);

    const currentItem = switcher.querySelector(
      '[data-lang="' + currentLocation.lang + '"]'
    );

    if (!label || !currentItem) return;

    const labelText = mediaQuery.matches
      ? currentItem.dataset.labelPc
      : currentItem.dataset.labelSp;

    label.textContent = labelText || currentLocation.lang;
  }

  function setCurrentItem(switcher) {
    const config = getSwitcherConfig(switcher);
    const currentLocation = getCurrentLocation(config);

    switcher.querySelectorAll("[data-lang]").forEach(function (item) {
      const isCurrent = item.dataset.lang === currentLocation.lang;

      item.classList.toggle("is-current", isCurrent);

      if (isCurrent) {
        item.setAttribute("aria-current", "true");
      } else {
        item.removeAttribute("aria-current");
      }
    });
  }

  function initializeLanguageSwitcher(switcher) {
    if (!switcher) return;
    if (switcher.dataset.initialized === "true") return;

    const button = switcher.querySelector("[data-fanclub-lang-button]");
    const menu = switcher.querySelector("[data-fanclub-lang-menu]");
    const items = switcher.querySelectorAll("[data-lang]");

    if (!button || !menu || !items.length) return;

    switcher.dataset.initialized = "true";

    setLabel(switcher);
    setCurrentItem(switcher);

    button.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (switcher.classList.contains("is-open")) {
        closeSwitcher(switcher);
      } else {
        openSwitcher(switcher);
      }
    });

    menu.addEventListener("click", function (event) {
      event.stopPropagation();
    });

    items.forEach(function (item) {
      item.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        const targetLang = item.dataset.lang;
        const destination = createLocalizedUrl(switcher, targetLang);

        closeSwitcher(switcher);

        if (
          destination ===
          window.location.pathname + window.location.search + window.location.hash
        ) {
          return;
        }

        window.location.assign(destination);
      });
    });
  }

  function initializeAllLanguageSwitchers(root) {
    const target = root || document;

    target
      .querySelectorAll("[data-fanclub-lang]")
      .forEach(initializeLanguageSwitcher);
  }

  function refreshAllLabels() {
    document.querySelectorAll("[data-fanclub-lang]").forEach(function (switcher) {
      setLabel(switcher);
      setCurrentItem(switcher);
    });
  }

  document.addEventListener("click", function () {
    document
      .querySelectorAll("[data-fanclub-lang].is-open")
      .forEach(closeSwitcher);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;

    document
      .querySelectorAll("[data-fanclub-lang].is-open")
      .forEach(closeSwitcher);
  });

  if (typeof mediaQuery.addEventListener === "function") {
    mediaQuery.addEventListener("change", refreshAllLabels);
  } else if (typeof mediaQuery.addListener === "function") {
    mediaQuery.addListener(refreshAllLabels);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initializeAllLanguageSwitchers(document);
    });
  } else {
    initializeAllLanguageSwitchers(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initializeAllLanguageSwitchers(event.target);
    refreshAllLabels();
  });
})();
